import { connect } from 'react-redux'
import { getBuka,getBukaChecklist,deleteBuka} from './actions'
import Setting from './main'


const mapDispatchToProps = {
    getBuka,
    getBukaChecklist,
    deleteBuka
}
const mapStateToProps = (state) => {
  return {
    ...state.BukaList
  }
}
  

export default connect(mapStateToProps, mapDispatchToProps)(Setting)
